/** @format */

import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Home from "./Home";
import Logo from "../assets/images/logo.png";
import LogoWhite from "../assets/images/logowhite.png";
import HireMain from "./HireMain";
import BlogMain from "./BlogMain";
import AdminLogin from "./AdminLogin";
import NavBar from "../components/NavBar";
import Admin from "./Admin";
import Background from "../components/Background";

class App extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	render() {
		return (
			<>
				<Router>
					<div className="container">
						<div className="row">
						<Background classes="back-one" />
						<Background classes="back-five" />
							<NavBar />
							<div className="col col-lg col-xl-9 offset-xl px-2 px-md">
								<Route exact path="/" component={Home} />
								<Route path="/hire" component={HireMain} />
								<Route path="/blog" component={BlogMain} />
								<Route
									path="/adminlogin"
									component={AdminLogin}
								/>
								<Route path="/admin" component={Admin} />
							</div>

							<div className="col col-lg col-xl-9 offset-xl px-2 px-md">
								<hr />
								<footer className="row">
									<div className="col-4 years">
										<p>© 2020</p>
									</div>
									<div className="col-6 col-lg-4">
										<img
											src={Logo}
											className="foot-logo dark"
											alt=""
										/>
										<img
											src={LogoWhite}
											className="foot-logo white"
											alt=""
										/>
									</div>
									<div className="col-6 col-lg-4 privacy">
										<p>
											Privacy — Terms <br />
											<span>&copy; 2020</span>
										</p>
									</div>
								</footer>
							</div>
						</div>
					</div>
				</Router>
			</>
		);
	}
}

export default App;
